import { formatUrl } from 'src/libs/url'
import { API_TEMPLATE } from '../libs/constant'
import { get, post, put } from '../libs/query'

const virtualAccountApi = {
  filterVirtualAccount ({ criteria, page, size }) {
		const path = API_TEMPLATE.VIRTUAL_CLASSIN_FILTER
		return post(path, { criteria, page, size })
	},
  importGGSheetVirtualAcc({ sheetId, sheetName }) {
		return post(`${API_TEMPLATE.VIRTUAL_CLASSIN_IMPORT}?sheetId=${sheetId}&sheetName=${sheetName}`)
	},
  exportGGSheetVirtualAcc({ sheetId, sheetName ,criteria, page, size}) {
		return post(`${API_TEMPLATE.VIRTUAL_CLASSIN_EXPORT}?sheetId=${sheetId}&sheetName=${sheetName}`,{
			criteria: criteria,
			page,
			size
		})
	},
  changePasswordVirtualAcc({ id, password }) {
		const path = formatUrl(API_TEMPLATE.VIRTUAL_CLASSIN_CHANGE_PASSWORD, [{ key: 'id', value: id }]);
		return post(path, { password });
	},
  statusVirtualAcc({ id, status }) {
		const path = formatUrl(API_TEMPLATE.VIRTUAL_CLASSIN_STATUS, [{ key: 'id', value: id }]);
		return put(path, { status })
	},
	getMgmtInAccount(id) {
		const path = `${API_TEMPLATE.VIRTUAL_CLASSIN_MGMT}/${id}`
		return get(path)
	},
}

export default virtualAccountApi
